'use client';

import { c as _c } from "react/compiler-runtime";
import { useBoolean } from 'minimal-shared/hooks';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Avatar from '@mui/material/Avatar';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { useRouter } from 'src/routes/hooks';
import { paths, newSearchParams } from 'src/routes/paths';
import { useTranslate } from 'src/locales';
import { FooterDesktop } from 'src/layouts/main/footer';
import { Iconify } from 'src/components/iconify';
import { Scrollbar } from 'src/components/scrollbar';
import { AccountTitle, AccountStatistics } from 'src/components/account-data';
import { useAuthContext } from 'src/auth/hooks';
import { SignInButton } from 'src/auth/components/sign-in-button';
import { SignOutButton } from 'src/auth/components/sign-out-button';
import { UpgradeBlock } from './nav-upgrade';
import { ThemeButton } from './theme-button';
import { AccountButton } from './account-button';
import { LanguagePopover } from './language-popover';
import { NotificationsDrawer } from './notifications-drawer';

// ----------------------------------------------------------------------

export function AccountDrawer(t0) {
  const $ = _c(151);
  let other;
  let sx;
  let t1;
  if ($[0] !== t0) {
    ({
      sx,
      layoutQuery: t1,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = sx;
    $[3] = t1;
  } else {
    other = $[1];
    sx = $[2];
    t1 = $[3];
  }
  const layoutQuery = t1 === undefined ? "md" : t1;
  const router = useRouter();
  const {
    t,
    currentLang
  } = useTranslate();
  const {
    user,
    authenticated
  } = useAuthContext();
  let t2;
  if ($[4] !== currentLang.countryName) {
    t2 = newSearchParams({
      country: currentLang.countryName
    });
    $[4] = currentLang.countryName;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const search = t2;
  const {
    value: open,
    onFalse: onClose,
    onTrue: onOpen
  } = useBoolean();
  const t3 = `${paths.user.root}${search}`;
  let T0;
  let T1;
  let T2;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] !== authenticated || $[7] !== currentLang.countryName || $[8] !== layoutQuery || $[9] !== onClose || $[10] !== onOpen || $[11] !== open || $[12] !== other || $[13] !== router || $[14] !== search || $[15] !== sx || $[16] !== t || $[17] !== t3 || $[18] !== user) {
    const MENU_USER = [{
      label: "Profile",
      icon: "fluent-color:scan-person-24",
      href: t3
    }, {
      label: "Favorites",
      icon: "fluent-color:heart-24",
      href: `${paths.shop}${newSearchParams({
        country: currentLang.countryName,
        list: "favorites"
      })}`
    }, {
      label: "Purchases",
      icon: "fluent-color:apps-list-20",
      href: `${paths.orders.purchases}${search}`
    }, {
      label: "Wallet",
      icon: "fluent-color:savings-24",
      href: `${paths.user.wallet}${search}`
    }];
    const MENU_SHOP = [{
      label: "Dashboard",
      icon: "fluent-color:poll-24",
      href: `${paths.analytics}${search}`
    }, {
      label: "Promotions",
      icon: "fluent-color:megaphone-loud-24",
      href: `${paths.promotions}${search}`
    }, {
      label: "Coupons",
      icon: "fluent-color:gift-card-24",
      href: `${paths.coupons}${search}`
    }, {
      label: "Sales",
      icon: "fluent-color:apps-list-detail-32",
      href: `${paths.orders.sales}${search}`
    }, {
      label: "Dispatch orders",
      icon: "fluent-color:clipboard-task-24",
      href: `${paths.orders.dispatch}${search}`
    }, {
      label: "Collaborators",
      icon: "fluent-color:people-24",
      href: `${paths.user.collaborators}${search}`
    }];
    let t20;
    if ($[38] !== onClose || $[39] !== router) {
      t20 = path => {
        onClose();
        router.push(path);
      };
      $[38] = onClose;
      $[39] = router;
      $[40] = t20;
    } else {
      t20 = $[40];
    }
    const handleRedirectTo = t20;
    let t21;
    if ($[41] !== handleRedirectTo || $[42] !== search || $[43] !== user?.displayName || $[44] !== user?.photoURL) {
      t21 = () => <Avatar src={user?.photoURL} alt={user?.displayName} onClick={() => handleRedirectTo(`${paths.user.account}${search}`)} sx={[_temp]} />;
      $[41] = handleRedirectTo;
      $[42] = search;
      $[43] = user?.displayName;
      $[44] = user?.photoURL;
      $[45] = t21;
    } else {
      t21 = $[45];
    }
    const renderAvatar = t21;
    let t22;
    if ($[46] !== handleRedirectTo || $[47] !== layoutQuery || $[48] !== t) {
      t22 = menu => menu.map(option => <MenuItem key={option.label} onClick={() => handleRedirectTo(option.href)} sx={{
        "&:hover": {
          color: "text.primary"
        },
        mb: {
          xs: "0 !important",
          [layoutQuery]: "8px !important"
        }
      }}><Iconify width={22} icon={option.icon} sx={{
          mr: 2
        }} /><Box component="span">{t(option.label)}</Box></MenuItem>);
      $[46] = handleRedirectTo;
      $[47] = layoutQuery;
      $[48] = t;
      $[49] = t22;
    } else {
      t22 = $[49];
    }
    const renderMenu = t22;
    const t23 = user?.photoURL;
    const t24 = user?.displayName;
    let t25;
    if ($[50] !== sx) {
      t25 = Array.isArray(sx) ? sx : [sx];
      $[50] = sx;
      $[51] = t25;
    } else {
      t25 = $[51];
    }
    let t26;
    if ($[52] !== t25) {
      t26 = [...t25];
      $[52] = t25;
      $[53] = t26;
    } else {
      t26 = $[53];
    }
    if ($[54] !== onOpen || $[55] !== other || $[56] !== t23 || $[57] !== t24 || $[58] !== t26) {
      t19 = <AccountButton onClick={onOpen} photoURL={t23} displayName={t24} sx={t26} {...other} />;
      $[54] = onOpen;
      $[55] = other;
      $[56] = t23;
      $[57] = t24;
      $[58] = t26;
      $[59] = t19;
    } else {
      t19 = $[59];
    }
    T2 = SwipeableDrawer;
    t10 = open;
    t11 = "right";
    t12 = onOpen;
    t13 = true;
    t14 = onClose;
    t15 = true;
    t16 = true;
    if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = {
        paper: {
          sx: {
            width: {
              xs: 1,
              md: 370
            }
          }
        }
      };
      $[60] = t17;
    } else {
      t17 = $[60];
    }
    let t27;
    if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
      t27 = {
        pb: 1,
        width: 1,
        display: "flex",
        alignItems: "center",
        pt: {
          xs: 2,
          md: 1
        },
        px: {
          xs: 2.5,
          md: 1.5
        },
        justifyContent: "space-between",
        backgroundColor: "background.default"
      };
      $[61] = t27;
    } else {
      t27 = $[61];
    }
    let t28;
    let t29;
    if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
      t28 = {
        display: {
          xs: "none",
          md: "flex"
        }
      };
      t29 = <Iconify icon="mingcute:close-line" />;
      $[62] = t28;
      $[63] = t29;
    } else {
      t28 = $[62];
      t29 = $[63];
    }
    let t30;
    if ($[64] !== onClose) {
      t30 = <IconButton onClick={onClose} sx={t28}>{t29}</IconButton>;
      $[64] = onClose;
      $[65] = t30;
    } else {
      t30 = $[65];
    }
    let t31;
    if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
      t31 = <LanguagePopover sx={{
        display: {
          md: "none"
        }
      }} />;
      $[66] = t31;
    } else {
      t31 = $[66];
    }
    let t32;
    if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
      t32 = {
        py: 0,
        display: {
          md: "none"
        }
      };
      $[67] = t32;
    } else {
      t32 = $[67];
    }
    let t33;
    if ($[68] !== onClose) {
      t33 = <NotificationsDrawer onCloseAccountDrawer={onClose} sx={t32} />;
      $[68] = onClose;
      $[69] = t33;
    } else {
      t33 = $[69];
    }
    if ($[70] !== t30 || $[71] !== t33) {
      t18 = <Box sx={t27}>{t30}{t31}{t33}</Box>;
      $[70] = t30;
      $[71] = t33;
      $[72] = t18;
    } else {
      t18 = $[72];
    }
    T1 = Scrollbar;
    let t34;
    if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
      t34 = {
        p: 3,
        pt: 6,
        backgroundColor: "background.default"
      };
      $[73] = t34;
    } else {
      t34 = $[73];
    }
    let t35;
    if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
      t35 = {
        p: 3,
        pt: 9,
        gap: 3,
        display: "flex",
        overflow: "visible",
        alignItems: "center",
        flexDirection: "column"
      };
      $[74] = t35;
    } else {
      t35 = $[74];
    }
    let t36;
    if ($[75] !== renderAvatar) {
      t36 = renderAvatar();
      $[75] = renderAvatar;
      $[76] = t36;
    } else {
      t36 = $[76];
    }
    let t37;
    let t38;
    if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
      t37 = {
        title: {
          sx: {
            typography: "subtitle1"
          }
        }
      };
      t38 = {
        justifyContent: "center"
      };
      $[77] = t37;
      $[78] = t38;
    } else {
      t37 = $[77];
      t38 = $[78];
    }
    let t39;
    if ($[79] !== user) {
      t39 = <AccountTitle user={user} slotProps={t37} sx={t38} />;
      $[79] = user;
      $[80] = t39;
    } else {
      t39 = $[80];
    }
    let t40;
    if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
      t40 = {
        display: "grid"
      };
      $[81] = t40;
    } else {
      t40 = $[81];
    }
    let t41;
    if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
      t41 = {
        color: "text.secondary",
        textAlign: "center",
        typography: "body2"
      };
      $[82] = t41;
    } else {
      t41 = $[82];
    }
    const t42 = user?.email;
    let t43;
    if ($[83] !== t42) {
      t43 = <Box sx={t40}><Box className="noWrap" sx={t41}>{t42}</Box></Box>;
      $[83] = t42;
      $[84] = t43;
    } else {
      t43 = $[84];
    }
    let t44;
    if ($[85] !== user?.id || $[86] !== user?.totalFollowers || $[87] !== user?.totalRating || $[88] !== user?.totalSales) {
      t44 = user?.id && <AccountStatistics justifyContent="center" totalSales={user?.totalSales} totalRating={user?.totalRating} totalFollowers={user?.totalFollowers} />;
      $[85] = user?.id;
      $[86] = user?.totalFollowers;
      $[87] = user?.totalRating;
      $[88] = user?.totalSales;
      $[89] = t44;
    } else {
      t44 = $[89];
    }
    let t45;
    if ($[90] !== t39 || $[91] !== t43 || $[92] !== t44) {
      t45 = <div>{t39}{t43}{t44}</div>;
      $[90] = t39;
      $[91] = t43;
      $[92] = t44;
      $[93] = t45;
    } else {
      t45 = $[93];
    }
    let t46;
    if ($[94] !== authenticated || $[95] !== onClose) {
      t46 = authenticated ? <SignOutButton onClose={onClose} /> : <SignInButton onClose={onClose} />;
      $[94] = authenticated;
      $[95] = onClose;
      $[96] = t46;
    } else {
      t46 = $[96];
    }
    if ($[97] !== t36 || $[98] !== t45 || $[99] !== t46) {
      t9 = <Box sx={t34}><Card sx={t35}>{t36}{t45}{t46}</Card></Box>;
      $[97] = t36;
      $[98] = t45;
      $[99] = t46;
      $[100] = t9;
    } else {
      t9 = $[100];
    }
    T0 = Box;
    if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = [_temp2];
      $[101] = t4;
    } else {
      t4 = $[101];
    }
    let t47;
    if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
      t47 = {
        p: 1,
        pb: {
          xs: 0,
          md: 1.5
        },
        typography: "overline"
      };
      $[102] = t47;
    } else {
      t47 = $[102];
    }
    let t48;
    if ($[103] !== t) {
      t48 = t("Account");
      $[103] = t;
      $[104] = t48;
    } else {
      t48 = $[104];
    }
    if ($[105] !== t48) {
      t5 = <Box sx={t47}>{t48}</Box>;
      $[105] = t48;
      $[106] = t5;
    } else {
      t5 = $[106];
    }
    t6 = renderMenu(MENU_USER);
    let t49;
    if ($[107] === Symbol.for("react.memo_cache_sentinel")) {
      t49 = {
        p: 1,
        pb: {
          xs: 0,
          md: 1.5
        },
        typography: "overline"
      };
      $[107] = t49;
    } else {
      t49 = $[107];
    }
    let t50;
    if ($[108] !== t) {
      t50 = t("Shop");
      $[108] = t;
      $[109] = t50;
    } else {
      t50 = $[109];
    }
    if ($[110] !== t50) {
      t7 = <Box sx={t49}>{t50}</Box>;
      $[110] = t50;
      $[111] = t7;
    } else {
      t7 = $[111];
    }
    t8 = renderMenu(MENU_SHOP);
    $[6] = authenticated;
    $[7] = currentLang.countryName;
    $[8] = layoutQuery;
    $[9] = onClose;
    $[10] = onOpen;
    $[11] = open;
    $[12] = other;
    $[13] = router;
    $[14] = search;
    $[15] = sx;
    $[16] = t;
    $[17] = t3;
    $[18] = user;
    $[19] = T0;
    $[20] = T1;
    $[21] = T2;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
    $[31] = t19;
    $[32] = t4;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
    $[37] = t9;
  } else {
    T0 = $[19];
    T1 = $[20];
    T2 = $[21];
    t10 = $[22];
    t11 = $[23];
    t12 = $[24];
    t13 = $[25];
    t14 = $[26];
    t15 = $[27];
    t16 = $[28];
    t17 = $[29];
    t18 = $[30];
    t19 = $[31];
    t4 = $[32];
    t5 = $[33];
    t6 = $[34];
    t7 = $[35];
    t8 = $[36];
    t9 = $[37];
  }
  let t20;
  if ($[112] !== T0 || $[113] !== t4 || $[114] !== t5 || $[115] !== t6 || $[116] !== t7 || $[117] !== t8) {
    t20 = <T0 sx={t4}>{t5}{t6}{t7}{t8}</T0>;
    $[112] = T0;
    $[113] = t4;
    $[114] = t5;
    $[115] = t6;
    $[116] = t7;
    $[117] = t8;
    $[118] = t20;
  } else {
    t20 = $[118];
  }
  let t21;
  if ($[119] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <UpgradeBlock sx={[_temp3]} />;
    $[119] = t21;
  } else {
    t21 = $[119];
  }
  let t22;
  if ($[120] !== layoutQuery) {
    t22 = {
      backgroundColor: "transparent",
      display: {
        [layoutQuery]: "none"
      }
    };
    $[120] = layoutQuery;
    $[121] = t22;
  } else {
    t22 = $[121];
  }
  let t23;
  if ($[122] !== layoutQuery || $[123] !== t22) {
    t23 = <FooterDesktop layoutQuery={layoutQuery} sx={t22} />;
    $[122] = layoutQuery;
    $[123] = t22;
    $[124] = t23;
  } else {
    t23 = $[124];
  }
  let t24;
  if ($[125] !== T1 || $[126] !== t20 || $[127] !== t23 || $[128] !== t9) {
    t24 = <T1>{t9}{t20}{t21}{t23}</T1>;
    $[125] = T1;
    $[126] = t20;
    $[127] = t23;
    $[128] = t9;
    $[129] = t24;
  } else {
    t24 = $[129];
  }
  let t25;
  let t26;
  if ($[130] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      px: 2,
      py: 1.5,
      justifyContent: "space-between",
      display: {
        xs: "flex",
        md: "none"
      }
    };
    t26 = <ThemeButton />;
    $[130] = t25;
    $[131] = t26;
  } else {
    t25 = $[130];
    t26 = $[131];
  }
  let t27;
  if ($[132] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Iconify icon="mingcute:close-line" />;
    $[132] = t27;
  } else {
    t27 = $[132];
  }
  let t28;
  if ($[133] !== onClose) {
    t28 = <Box sx={t25}>{t26}<IconButton onClick={onClose}>{t27}</IconButton></Box>;
    $[133] = onClose;
    $[134] = t28;
  } else {
    t28 = $[134];
  }
  let t29;
  if ($[135] !== T2 || $[136] !== t10 || $[137] !== t11 || $[138] !== t12 || $[139] !== t13 || $[140] !== t14 || $[141] !== t15 || $[142] !== t16 || $[143] !== t17 || $[144] !== t18 || $[145] !== t24 || $[146] !== t28) {
    t29 = <T2 open={t10} anchor={t11} onOpen={t12} disableDiscovery={t13} onClose={t14} disableSwipeToOpen={t15} disableBackdropTransition={t16} slotProps={t17}>{t18}{t24}{t28}</T2>;
    $[135] = T2;
    $[136] = t10;
    $[137] = t11;
    $[138] = t12;
    $[139] = t13;
    $[140] = t14;
    $[141] = t15;
    $[142] = t16;
    $[143] = t17;
    $[144] = t18;
    $[145] = t24;
    $[146] = t28;
    $[147] = t29;
  } else {
    t29 = $[147];
  }
  let t30;
  if ($[148] !== t19 || $[149] !== t29) {
    t30 = <>{t19}{t29}</>;
    $[148] = t19;
    $[149] = t29;
    $[150] = t30;
  } else {
    t30 = $[150];
  }
  return t30;
}
function _temp3(theme_1) {
  return {
    borderBottom: `dashed 1px ${theme_1.vars.palette.divider}`
  };
}
function _temp2(theme_0) {
  return {
    p: 2,
    borderTop: `dashed 1px ${theme_0.vars.palette.divider}`,
    borderBottom: `dashed 1px ${theme_0.vars.palette.divider}`
  };
}
function _temp(theme) {
  return {
    top: -40,
    cursor: "pointer",
    position: "absolute",
    width: {
      xs: 92,
      md: 88
    },
    height: {
      xs: 92,
      md: 88
    },
    border: `solid 2px ${theme.palette.common.white}`
  };
}